<template>
  <div class="game-frame">
    <StageFrame /> <!-- Contains the main game PIXI app -->

    <div class="frame-bush">
      <img
        v-for="(c, i) in 10"
        :key="i"
        src="/img/misc/farfalla.gif"
        alt=""
        :class="['frame-bush__butterfly', `frame-bush__butterfly--${i}`]"
      />
    </div>

    <UIFrame /> <!-- Contains the HTML UI overlay -->

    <div class="game-frame__overlay">
      <div class="game-frame__overlay-difference"></div>
    </div>
  </div>
</template>

<script>
import StageFrame from '@/components/StageFrame.vue';
import UIFrame from '@/components/UIFrame.vue';

export default {
  name: 'GameFrame',

  components: {
    StageFrame,
    UIFrame,
  },
};
</script>

<style lang="scss">
.game-frame {
  position: relative;
  width: calc(375px * var(--rw));
  height: calc(812px * var(--rw));

  align-self: flex-end;

  &__overlay {
    @extend %full;

    opacity: 0;
    display: none;

    background-image: url('/img/iphonex-layer.png');
    pointer-events: none;

    &-difference {
      position: absolute;
      width: $frame-difference-width;
      height: $frame-difference-height;
      top: $frame-difference-top;
      // background-color: lightslategray;
      border-top: 1px solid red;
      border-bottom-left-radius: 40px;
      border-bottom-right-radius: 40px;
    }
  }

  .frame-bush {
    @extend %full-fixed;
    bottom: 0px;
    pointer-events: none;

    background-image: url('/img/misc/frame.png');
    background-position: center bottom;
    background-size: auto 100%;
    background-repeat: no-repeat;

    // &::before,
    // &::after {
    //   content: ' ';
    //   position: absolute;
    //   top: 0px;
    //   width: 100vw;
    //   height: 100vh;
    //   height: calc(var(--vh, 1vh) * 100);

    //   background-image: url('/img/misc/repeater.png');
    // }

    // &::before {
    //   left: calc(-1200px * var(--rw));
    // }

    // &::after {
    //   left: calc(1200px * var(--rw));
    // }

    @include mq($until: ipadP) {
      display: none;
    }

    &__butterfly {
      position: absolute;

      &--0 {
        left: 10vw;
        top: 10vh;
        transform: scale(0.2) rotate(10deg);
      }
      &--1 {
        left: 20vw;
        top: 30vh;
        transform: scale(0.2) rotate(-10deg);
      }
      &--2 {
        left: 32vw;
        top: 15vh;
        transform: scale(0.2) rotate(-15deg);
      }
      &--3 {
        left: 20vw;
        top: 80vh;
        transform: scale(0.2) rotate(10deg);
      }
      &--4 {
        left: 5vw;
        top: 60vh;
        transform: scale(0.2) rotate(10deg);
      }

      &--5 {
        right: 20vw;
        top: 10vh;
        transform: scale(0.2) rotate(10deg);
      }
      &--6 {
        right: 5vw;
        top: 30vh;
        transform: scale(0.2) rotate(-10deg);
      }
      &--7 {
        right: 23vw;
        top: 40vh;
        transform: scale(0.2) rotate(-15deg);
      }
      &--8 {
        right: 15vw;
        top: 60vh;
        transform: scale(0.2) rotate(10deg);
      }
      &--9 {
        right: 8vw;
        top: 75vh;
        transform: scale(0.2) rotate(10deg);
      }
    }
  }
}
</style>
